import { Directive, inject, TemplateRef } from '@angular/core';

/**
 * Marcador para o template de conteúdo de linha expansível.
 * Uso:
 * ```html
 * <ng-template companyExpandDef let-row="row">
 *   {{ row.description }}
 * </ng-template>
 * ```
 * O contexto disponível é `{ $implicit: row, row: T, rowIndex: number }`.
 */
@Directive({ selector: 'ng-template[companyExpandDef]' })
export class CompanyExpandDefDirective {
  readonly template = inject(TemplateRef<{ $implicit: unknown; row: unknown; rowIndex: number }>);
}
